export default __webpack_public_path__ + "static/media/avatar_lion1.e6a1e930.mp3";